import { cn } from "@/lib/utils";

export enum StatusState {
  Ok = "OK",
  Err = "ERR",
  Warn = "WARN",
}

export function StatusItem({
  label,
  status,
  className,
}: {
  label: string;
  status: StatusState;
  className?: string;
}) {
  return (
    <div
      className={cn("flex items-center gap-x-3", className)}
      aria-label={label + "-" + status}
    >
      <span
        className={cn(
          "inline-block rounded-full w-2 h-2 ring-1 ring-offset-1 flex-shrink-0",
          {
            "bg-success ring-success": status === StatusState.Ok,
            "bg-warning ring-warning": status === StatusState.Warn,
            "bg-destructive ring-destructive": status === StatusState.Err,
          }
        )}
      ></span>
      <span className="text-sm text-ellipsis overflow-hidden w-full">
        {label}
      </span>
    </div>
  );
}
